module.exports = __webpack_public_path__ + "img/fc-flora.974e1b5f.png";